(function () {
  function resolveSelection(data, color, pack, preferredId, packCount = 1) {
    const matching = data.products.filter(p => p.color === color && Number(p.pack) === pack);
    let item = matching.find(p => String(p.id) === String(preferredId)) || matching.find(p => p.available) || matching[0];
    let quantity = 1;
    if (!item && !data.nutrition) {
      const singles = data.products.filter(p => p.color === color && Number(p.pack) === 1);
      item = singles.find(p => p.available) || singles[0];
      quantity = pack;
    }
    if (!item) return null;
    quantity *= packCount;
    const min = Number(item.min) || 1;
    const increment = Number(item.increment) || 1;
    const stockOK = !item.tracked || item.policy === 'continue' || Number(item.stock) >= quantity;
    const quantityOK = Number.isSafeInteger(packCount) && packCount > 0 && Number.isSafeInteger(quantity) && quantity >= min && (!item.max || quantity <= Number(item.max)) && (quantity - min) % increment === 0;
    return { item, quantity, total: item.price * quantity, compare: (item.compare || 0) * quantity, available: Boolean(item.available && stockOK && quantityOK) };
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { resolveSelection }; return; }
  function init(root) {
    if (root.dataset.ready) return;
    let data;
    try { data = JSON.parse(root.querySelector('[data-landing-data]').textContent); } catch (_) { return; }
    if (!data.products.length) return;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const colors = $$('[data-colour]');
    const packs = $$('[data-pack]');
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: data.currency || 'INR', maximumFractionDigits: value % 100 ? 2 : 0 }).format(value / 100);
    let color = data.color;
    let pack = Number(data.pack);
    let packCount = 1;
    let selected;
    let imageProduct = data.initialVariantId;
    let galleryImages = (data.products.find(item => item.id === imageProduct)?.images || []);
    let imageIndex = 0;
    const zoomDialog = $('[data-zoom-dialog]');
    const initialParams = new URL(location.href).searchParams;
    const requestedPack = Number(initialParams.get('pack'));
    if (packs.some(button => Number(button.dataset.pack) === requestedPack)) pack = requestedPack;
    function showImage(image) {
      imageIndex = Math.max(0, galleryImages.findIndex(entry => entry.src === image.src));
      const main = $('.kslp__main-image');
      const src = new URL(image.src, location.origin);
      main.srcset = image.srcset || [320, 480, 720, 960, 1200].map(width => { const resized = new URL(src); resized.searchParams.set('width', width); return `${resized} ${width}w`; }).join(', ');
      main.src = image.src;
      main.alt = image.alt || data.family;
      if (image.width && image.height) { main.width = image.width; main.height = image.height; }
      $$('[data-image-url]').forEach(button => {
        const active = button.dataset.imageUrl === image.src;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('is-selected', active);
      });
      if (zoomDialog.open) updateZoom();
    }
    function updateZoom() {
      const image = galleryImages[imageIndex];
      if (!image) return;
      $('[data-zoom-image]').src = image.zoom || image.src;
      $('[data-zoom-image]').alt = image.alt || data.family;
      $('[data-zoom-caption]').textContent = `${imageIndex + 1} / ${galleryImages.length}`;
      $('[data-zoom-prev]').disabled = galleryImages.length < 2;
      $('[data-zoom-next]').disabled = galleryImages.length < 2;
    }
    function moveImage(direction) {
      const next = (imageIndex + direction + galleryImages.length) % galleryImages.length;
      if (galleryImages[next]) showImage(galleryImages[next]);
    }
    function updateImages(item) {
      if (imageProduct === item.id || !item.images.length) return;
      imageProduct = item.id;
      galleryImages = item.images;
      const thumbs = $('[data-thumbnails]');
      thumbs.replaceChildren();
      item.images.forEach((image, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kslp__thumb';
        button.dataset.imageUrl = image.src;
        button.setAttribute('aria-label', `${data.labels.image} ${index + 1}`);
        const img = document.createElement('img');
        img.src = image.thumb; img.alt = ''; img.loading = 'lazy'; img.width = 120; img.height = 120;
        button.append(img); thumbs.append(button);
      });
      showImage(item.images[0]);
    }
    function update(changeUrl) {
      const preferredId = changeUrl ? null : data.initialVariantId;
      const packSelection = resolveSelection(data, color, pack, preferredId);
      selected = resolveSelection(data, color, pack, preferredId, packCount);
      if (!selected) return;
      const { item, quantity, total, available } = selected;
      const { total: packPrice, compare } = packSelection;
      root.classList.toggle('is-unavailable', !available);
      colors.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.colour === color));
        const hasStock = packs.some(p => resolveSelection(data, button.dataset.colour, Number(p.dataset.pack))?.available);
        button.classList.toggle('is-unavailable', !hasStock);
        button.setAttribute('aria-label', `${button.dataset.colour}${hasStock ? '' : ` — ${data.labels.soldOut}`}`);
      });
      packs.forEach(button => {
        const count = Number(button.dataset.pack);
        const option = resolveSelection(data, color, count);
        button.setAttribute('aria-pressed', String(count === pack));
        button.disabled = !option;
        button.querySelector('[data-pack-price]').textContent = option ? money(option.total) : '—';
        button.setAttribute('aria-label', `${data.labels.packOf} ${count}${option ? `, ${money(option.total)}${option.available ? '' : `, ${data.labels.soldOut}`}` : `, ${data.labels.unavailable}`}`);
      });
      const rating = $('[data-rating]');
      rating.hidden = !item.rating;
      rating.textContent = item.rating ? `★ ${item.rating} / ${item.ratingMax || 5}${item.ratingCount ? ` · ${item.ratingCount} ${Number(item.ratingCount) === 1 ? data.labels.review : data.labels.reviews}` : ''}` : '';
      $('[data-colour-label]').textContent = color;
      $('[data-price]').textContent = money(packPrice);
      $('[data-compare]').hidden = compare <= packPrice;
      $('[data-compare]').textContent = money(compare);
      $('[data-saving]').textContent = compare > packPrice ? `${Math.round((compare - packPrice) / compare * 100)}% ${data.labels.off}` : '';
      $('[data-unit-price]').textContent = `${money(Math.round(packPrice / (pack * data.unitCount)))} ${data.labels.perUnit}`;
      const countValid = Number.isSafeInteger(packCount) && packCount > 0;
      $('[data-pack-quantity]').setAttribute('aria-invalid', String(!countValid));
      $('[data-availability]').textContent = !countValid ? data.orderLabels.quantityInvalid : available ? data.labels.available : packSelection.available ? data.orderLabels.quantityUnavailable : data.labels.soldOut;
      $('[data-variant-input]').value = item.id;
      $('[data-quantity-input]').value = quantity;
      $('[data-cart-pack-size]').value = pack;
      $('[data-cart-pack-units]').value = quantity / packCount;
      $('[data-cart-pack-size]').disabled = !(quantity / packCount > 1);
      $('[data-cart-pack-units]').disabled = !(quantity / packCount > 1);
      $('[data-quantity-minus]').disabled = packCount <= 1;
      $('[data-quantity-plus]').disabled = !resolveSelection(data, color, pack, item.id, packCount + 1)?.available;
      $('[data-subtotal]').hidden = packCount <= 1 || !Number.isSafeInteger(packCount);
      $('[data-subtotal]').textContent = `${data.orderLabels.total}: ${money(total)}`;
      $('[data-buy-now]').disabled = !available;
      $('[data-add]').disabled = !available;
      $('[data-add]').firstChild.textContent = packSelection.available ? data.labels.add : data.labels.soldOut;
      $('[data-sticky-add]').disabled = !available;
      $('[data-sticky-add]').textContent = packSelection.available ? data.labels.add : data.labels.soldOut;
      const caption = `${color} · ${data.labels.packOf} ${pack}`;
      $('[data-selection-caption]').textContent = caption;
      $('[data-sticky-selection]').textContent = `${caption}${packCount > 1 ? ` · ${data.orderLabels.quantity} ${packCount}` : ''} · ${money(total)}`;
      updateImages(item);
      if (changeUrl) {
        const url = new URL(item.url, location.origin);
        const existing = new URL(location.href);
        existing.searchParams.forEach((value, key) => { if (!['variant', 'pack'].includes(key)) url.searchParams.set(key, value); });
        url.searchParams.set('variant', item.id);
        url.searchParams.set('pack', pack);
        history.replaceState(null, '', url);
      }
    }
    $('[data-thumbnails]').addEventListener('click', event => {
      const button = event.target.closest('[data-image-url]');
      const image = galleryImages.find(entry => entry.src === button?.dataset.imageUrl);
      if (image) showImage(image);
    });
    if (typeof zoomDialog.showModal === 'function' && galleryImages.length) {
      $('[data-zoom-open]').hidden = false;
      $('[data-zoom-open]').addEventListener('click', () => { updateZoom(); zoomDialog.showModal(); });
      $('[data-zoom-close]').addEventListener('click', () => zoomDialog.close());
      $('[data-zoom-prev]').addEventListener('click', () => moveImage(-1));
      $('[data-zoom-next]').addEventListener('click', () => moveImage(1));
      zoomDialog.addEventListener('click', event => { if (event.target === zoomDialog) zoomDialog.close(); });
      zoomDialog.addEventListener('keydown', event => {
        if (['ArrowLeft', 'ArrowRight'].includes(event.key)) { event.preventDefault(); moveImage(event.key === 'ArrowRight' ? 1 : -1); }
      });
    }
    colors.forEach(button => button.addEventListener('click', () => { color = button.dataset.colour; update(true); }));
    packs.forEach(button => button.addEventListener('click', () => { pack = Number(button.dataset.pack); update(true); }));
    const quantityInput = $('[data-pack-quantity]');
    const changeQuantity = count => { packCount = count; quantityInput.value = count; update(false); };
    quantityInput.addEventListener('input', () => { packCount = Number(quantityInput.value); update(false); });
    quantityInput.addEventListener('blur', () => { if (!Number.isSafeInteger(packCount) || packCount < 1) changeQuantity(1); });
    $('[data-quantity-minus]').addEventListener('click', () => changeQuantity(Math.max(1, packCount - 1)));
    $('[data-quantity-plus]').addEventListener('click', () => changeQuantity(packCount + 1));
    $('[data-order-quantity]').hidden = false;
    $('.kslp__form').addEventListener('submit', event => { if (!selected?.available) event.preventDefault(); });
    update(false);
    root.dataset.ready = 'true';
    root.classList.add('is-enhanced');
    if ('IntersectionObserver' in window) {
      const sticky = $('[data-sticky]');
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, { threshold: 0 });
      observer.observe($('.kslp__form'));
    }
  }
  document.querySelectorAll('[data-kslp]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kslp]').forEach(init));
})();
